import React, { useState, useEffect, useContext } from 'react';
import { Button, Input, Table, Typography, Modal, Select, message } from 'antd';
import { PrinterOutlined, PlusOutlined, CloseOutlined, FilePdfOutlined } from '@ant-design/icons';
import html2pdf from "html2pdf.js";
import axios from 'axios';
import { AuthContext } from "../context/AuthContext"
import ExitInterview from '../pages/ExitInterview';
import ViewNocForm from "./ViewNocForm";


const { Title, Text } = Typography;
const { TextArea } = Input;
const { Option } = Select;

export default function NocForm({ employee, backurl, bearerToken, requestId }) {

    console.log("employeee : ", employee)

    const [formData, setFormData] = useState({
        name: employee?.name || '',
        empNo: employee?.empNo || '',
        designation: employee?.designation || '',
        dept: employee?.dept || '',
        joiningDate: employee?.joiningDate || '',
        resignationDate: '',
        relievingDate: '',
        address: '',
        phone: ''
    });

    const [clearanceFormData, setClearanceFormData] = useState(null);
    const { authData, backUrl } = useContext(AuthContext);

    const [view, setView] = useState(false)

    // Initialize as empty arrays
    const [deptItems, setDeptItems] = useState([]);
    const [itItems, setItItems] = useState([]);
    const [financeItems, setFinanceItems] = useState([]);
    const [hrItems, setHrItems] = useState([]);

    // Separate state for rows (editable data)
    const [deptRows, setDeptRows] = useState([]);
    const [itRows, setItRows] = useState([]);
    const [financeRows, setFinanceRows] = useState([]);
    const [hrRows, setHrRows] = useState([]);

    const fetchDeptItems = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/clearance/dept-section/`, {
                headers: {
                    Authorization: `Bearer ${authData?.access}`
                }
            });

            if (res.data.results && res.data.results.length > 0) {
                // Extract items from the nested structure
                const items = res.data.results[0].items || [];
                const transformedItems = items.map((item, index) => ({
                    key: String(item.id || index),
                    id: item.id,
                    item_name: item.item_name,
                    status: item.status || ''
                }));
                setDeptItems(transformedItems);
                setDeptRows(transformedItems);
            }
        } catch (error) {
            console.error('Error fetching dept items:', error);
        }
    };

    const fetchItItems = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/clearance/it-section/`, {
                headers: {
                    Authorization: `Bearer ${authData?.access}`
                }
            });

            if (res.data.results && res.data.results.length > 0) {
                const items = res.data.results[0].items || [];
                const transformedItems = items.map((item, index) => ({
                    key: String(item.id || index),
                    id: item.id,
                    item_name: item.item_name,
                    status: item.status || ''
                }));
                setItItems(transformedItems);
                setItRows(transformedItems);
            }
        } catch (error) {
            console.error('Error fetching IT items:', error);
        }
    };

    const fetchHrItems = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/clearance/hr-section/`, {
                headers: {
                    Authorization: `Bearer ${authData?.access}`
                }
            });

            if (res.data.results && res.data.results.length > 0) {
                const items = res.data.results[0].items || [];
                const transformedItems = items.map((item, index) => ({
                    key: String(item.id || index),
                    id: item.id,
                    item_name: item.item_name,
                    status: item.status || ''
                }));
                setHrItems(transformedItems);
                setHrRows(transformedItems);
            }
        } catch (error) {
            console.error('Error fetching HR items:', error);
        }
    };

    const fetchFinanceItems = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/clearance/finance-section/`, {
                headers: {
                    Authorization: `Bearer ${authData?.access}`
                }
            });

            if (res.data.results && res.data.results.length > 0) {
                const items = res.data.results[0].items || [];
                const transformedItems = items.map((item, index) => ({
                    key: String(item.id || index),
                    id: item.id,
                    item_name: item.item_name,
                    amount: item.amount || ''
                }));
                setFinanceItems(transformedItems);
                setFinanceRows(transformedItems);
            }
        } catch (error) {
            console.error('Error fetching finance items:', error);
        }
    };

    useEffect(() => {
        fetchDeptItems();
        fetchFinanceItems();
        fetchHrItems();
        fetchItItems();
    }, []);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [loading, setLoading] = useState(false);
    const [clearanceData, setClearanceData] = useState({
        correspondence_address: '',
        assigned_dept_head: null,
        assigned_it_approver: null,
        assigned_finance_approver: null,
        assigned_hr_approver: null
    });

    const [rid, setRid] = useState(0);

    const getRequestId = async () => {
        const res = await axios.get(`${backUrl}/api/clearance/requests/?emp_no=${employee?.user?.username}`, {
            headers: {
                Authorization: `Bearer ${authData?.access}`
            }
        });

        setRid(res.data.results[0])
        console.log("response : ", res.data)
    }

    const currentDate = new Date().toLocaleDateString("en-GB");

    useEffect(() => {
        fetchEmployees();
        fetchClearanceForm();
        getRequestId();
    }, []);

    const fetchEmployees = async () => {
        try {
            const response = await axios.get(`${backUrl}/api/emp/employees`, {
                headers: {
                    'Authorization': `Bearer ${authData?.access}`,
                    'Content-Type': 'application/json'
                }
            });
            setEmployees(response.data.results);
        } catch (error) {
            console.error('Error fetching employees:', error);
            message.error('Error fetching employees');
        }
    };

    const fetchClearanceForm = async () => {
        try {
            const response = await axios.get(`${backUrl}/api/clearance/requests/?employee=${employee.id}`, {
                headers: {
                    'Authorization': `Bearer ${authData?.access}`,
                    'Content-Type': 'application/json'
                }
            });
            if (response.data.results && response.data.results.length > 0) {
                setClearanceFormData(response.data.results[0]);
            }
        } catch (error) {
            console.error('Error fetching clearance form:', error);
        }
    };

    const handleCreateForm = () => {
        setIsModalOpen(true);
    };

    const handleViewForm = () => {
        setView(true)
    }

    const handleModalOk = async () => {
        if (!clearanceData.correspondence_address ||
            !clearanceData.assigned_dept_head ||
            !clearanceData.assigned_it_approver ||
            !clearanceData.assigned_finance_approver ||
            !clearanceData.assigned_hr_approver) {
            message.error('Please fill all required fields');
            return;
        }

        setLoading(true);

        const payload = {
            employee: employee.id || employee.emp_id,
            emp_no: employee.emp_code,
            designation: employee.designation_name,
            department: employee.department_name,
            joining_date: employee.date_of_joining,
            resignation_date: employee.date_of_leaving,
            relieving_date: employee.last_working_day,
            correspondence_address: clearanceData.correspondence_address,
            assigned_dept_head: clearanceData.assigned_dept_head,
            assigned_it_approver: clearanceData.assigned_it_approver,
            assigned_finance_approver: clearanceData.assigned_finance_approver,
            assigned_hr_approver: clearanceData.assigned_hr_approver
        };

        try {
            const response = await axios.post(`${backUrl}/api/clearance/requests/`, payload, {
                headers: {
                    'Authorization': `Bearer ${authData?.access}`,
                    'Content-Type': 'application/json'
                },
            });

            message.success('Clearance form created successfully!');
            setIsModalOpen(false);
            setClearanceData({
                correspondence_address: '',
                assigned_dept_head: null,
                assigned_it_approver: null,
                assigned_finance_approver: null,
                assigned_hr_approver: null
            });
            fetchClearanceForm();
        } catch (error) {
            console.error('Error creating clearance form:', error);
            message.error(error.response?.data?.message || 'Error creating clearance form');
        } finally {
            setLoading(false);
        }
    };

    const handleModalCancel = () => {
        setIsModalOpen(false);
    };

    // Submit handlers for each section
    const handleDeptSubmit = async () => {
        const payload = {
            handing_over_to_name: employee?.first_name,
            is_employee_signed: true,
            is_receiver_confirmed: true,
            is_approved_by_head: true,
            items: deptRows.map(row => ({
                id: row.id,
                status: row.status
            }))
        };


        try {
            const response = await axios.patch(`${backUrl}/api/clearance/dept-section/${requestId}/`, payload, {
                headers: {
                    'Authorization': `Bearer ${authData?.access}`,
                    'Content-Type': 'application/json'
                }
            });
            message.success('Department clearance submitted successfully!');
        } catch (error) {
            console.error('Error submitting department clearance:', error);
            message.error('Error submitting department clearance');
        }
    };

    const handleItSubmit = async () => {
        const payload = {
            handing_over_to_name: employee?.first_name,
            is_employee_signed: true,
            is_receiver_confirmed: true,
            is_approved_by_head: true,
            items: itRows.map(row => ({
                id: row.id,
                response_value: row.status
            }))
        };

        try {
            const response = await axios.patch(`${backUrl}/api/clearance/it-section/${requestId}/`, payload, {
                headers: {
                    'Authorization': `Bearer ${authData?.access}`,
                    'Content-Type': 'application/json'
                }
            });
            message.success('IT clearance submitted successfully!');
        } catch (error) {
            console.error('Error submitting IT clearance:', error);
            message.error('Error submitting IT clearance');
        }
    };

    const handleFinanceSubmit = async () => {
        const payload = {
            clearance_form_id: clearanceFormData?.id,
            section: 'finance',
            employee_id: employee.id,
            submitted_by: authData?.employee?.id,
            finance_clearance_data: financeRows.map(row => ({
                id: row.id,
                item_name: row.item_name,
                amount: row.amount
            })),
            submission_date: new Date().toISOString()
        };

        try {
            const response = await axios.patch(`${backUrl}/api/clearance/finance-section/${requestId}/`, payload, {
                headers: {
                    'Authorization': `Bearer ${authData?.access}`,
                    'Content-Type': 'application/json'
                }
            });
            message.success('Finance clearance submitted successfully!');
        } catch (error) {
            console.error('Error submitting finance clearance:', error);
            message.error('Error submitting finance clearance');
        }
    };

    const handleHrSubmit = async () => {
        const payload = {
            clearance_form_id: clearanceFormData?.id,
            section: 'hr',
            employee_id: employee.id,
            submitted_by: authData?.employee?.id,
            hr_clearance_data: hrRows.map(row => ({
                id: row.id,
                item_name: row.item_name,
                status: row.status
            })),
            correspondence_address: formData.address,
            phone_number: formData.phone,
            submission_date: new Date().toISOString()
        };

        try {
            const response = await axios.patch(`${backUrl}/api/clearance/hr-section/${rid.id}/`, payload, {
                headers: {
                    'Authorization': `Bearer ${authData?.access}`,
                    'Content-Type': 'application/json'
                }
            });
            message.success('HR clearance submitted successfully!');
        } catch (error) {
            console.error('Error submitting HR clearance:', error);
            message.error('Error submitting HR clearance');
        }
    };

    // Check if current user is assigned to a section
    const isDeptHeadAssigned = () => {
        return clearanceFormData?.assigned_dept_head === authData?.employee?.id;
    };

    const isItApproverAssigned = () => {
        return clearanceFormData?.assigned_it_approver === authData?.employee?.id;
    };

    const isFinanceApproverAssigned = () => {
        return clearanceFormData?.assigned_finance_approver === authData?.employee?.id;
    };

    const isHrApproverAssigned = () => {
        return clearanceFormData?.assigned_hr_approver === authData?.employee?.id;
    };

    const handleDownloadPDF = () => {
        const element = document.getElementById("noc-pdf");

        const options = {
            margin: [10, 10, 10, 10],
            filename: `Employee_Clearance_${employee?.emp_code || "Form"}.pdf`,
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: {
                scale: 2,
                useCORS: true,
            },
            jsPDF: {
                unit: "mm",
                format: "a4",
                orientation: "portrait",
            },
            pagebreak: { mode: ["css", "legacy"] }
        };

        html2pdf().set(options).from(element).save();
    };

    // Department table handlers
    const addDeptRow = () => {
        const newKey = String(Date.now());
        setDeptRows([...deptRows, { key: newKey, item_name: '', status: '' }]);
    };

    const deleteDeptRow = (key) => {
        if (deptRows.length > 1) {
            setDeptRows(deptRows.filter(row => row.key !== key));
        }
    };

    const updateDeptRow = (key, field, value) => {
        setDeptRows(deptRows.map(row =>
            row.key === key ? { ...row, [field]: value } : row
        ));
    };

    const saveDeptRow = async (row) => {
        if (!row.item_name) {
            message.error('Please enter item name');
            return;
        }

        try {
            // Get the serial number (index + 1)
            const serialNo = deptRows.findIndex(r => r.key === row.key) + 1;

            if (row.id) {
                await axios.patch(`${backUrl}/api/clearance/dept-items/${row.id}/`, {
                    section: serialNo,
                    item_name: row.item_name,
                    status: row.status
                }, {
                    headers: {
                        'Authorization': `Bearer ${authData?.access}`,
                        'Content-Type': 'application/json'
                    }
                });
                message.success('Department item updated successfully!');
            } else {
                const response = await axios.post(`${backUrl}/api/clearance/dept-items/`, {
                    section: serialNo,
                    item_name: row.item_name,
                    status: row.status
                }, {
                    headers: {
                        'Authorization': `Bearer ${authData?.access}`,
                        'Content-Type': 'application/json'
                    }
                });

                setDeptRows(deptRows.map(r =>
                    r.key === row.key ? { ...r, id: response.data.id } : r
                ));
                message.success('Department item added successfully!');
            }
            fetchDeptItems();
        } catch (error) {
            console.error('Error saving department item:', error);
            message.error(error.response?.data?.message || 'Error saving department item');
        }
    };

    // IT table handlers
    const addItRow = () => {
        const newKey = String(Date.now());
        setItRows([...itRows, { key: newKey, item_name: '', status: '' }]);
    };

    const deleteItRow = (key) => {
        if (itRows.length > 1) {
            setItRows(itRows.filter(row => row.key !== key));
        }
    };

    const updateItRow = (key, field, value) => {
        setItRows(itRows.map(row =>
            row.key === key ? { ...row, [field]: value } : row
        ));
    };

    const saveItRow = async (row) => {
        if (!row.item_name) {
            message.error('Please enter item name');
            return;
        }

        try {
            // Get the serial number (index + 1)
            const serialNo = itRows.findIndex(r => r.key === row.key) + 1;

            if (row.id) {
                await axios.patch(`${backUrl}/api/clearance/it-items/${row.id}/`, {
                    section: serialNo,
                    item_name: row.item_name,
                    status: row.status
                }, {
                    headers: {
                        'Authorization': `Bearer ${authData?.access}`,
                        'Content-Type': 'application/json'
                    }
                });
                message.success('IT item updated successfully!');
            } else {
                const response = await axios.post(`${backUrl}/api/clearance/it-items/`, {
                    section: serialNo,
                    item_name: row.item_name,
                    status: row.status
                }, {
                    headers: {
                        'Authorization': `Bearer ${authData?.access}`,
                        'Content-Type': 'application/json'
                    }
                });

                setItRows(itRows.map(r =>
                    r.key === row.key ? { ...r, id: response.data.id } : r
                ));
                message.success('IT item added successfully!');
            }
            fetchItItems();
        } catch (error) {
            console.error('Error saving IT item:', error);
            message.error(error.response?.data?.message || 'Error saving IT item');
        }
    };

    // Finance table handlers
    const addFinanceRow = () => {
        const newKey = String(Date.now());
        setFinanceRows([...financeRows, { key: newKey, item_name: '', amount: '' }]);
    };

    const deleteFinanceRow = (key) => {
        if (financeRows.length > 1) {
            setFinanceRows(financeRows.filter(row => row.key !== key));
        }
    };

    const updateFinanceRow = (key, field, value) => {
        setFinanceRows(financeRows.map(row =>
            row.key === key ? { ...row, [field]: value } : row
        ));
    };

    const saveFinanceRow = async (row) => {
        if (!row.item_name) {
            message.error('Please enter item name');
            return;
        }

        try {
            // Get the serial number (index + 1)
            const serialNo = financeRows.findIndex(r => r.key === row.key) + 1;

            if (row.id) {
                await axios.patch(`${backUrl}/api/clearance/finance-items/${row.id}/`, {
                    section: serialNo,
                    item_name: row.item_name,
                    amount: row.amount
                }, {
                    headers: {
                        'Authorization': `Bearer ${authData?.access}`,
                        'Content-Type': 'application/json'
                    }
                });
                message.success('Finance item updated successfully!');
            } else {
                const response = await axios.post(`${backUrl}/api/clearance/finance-items/`, {
                    section: serialNo,
                    item_name: row.item_name,
                    amount: row.amount
                }, {
                    headers: {
                        'Authorization': `Bearer ${authData?.access}`,
                        'Content-Type': 'application/json'
                    }
                });

                setFinanceRows(financeRows.map(r =>
                    r.key === row.key ? { ...r, id: response.data.id } : r
                ));
                message.success('Finance item added successfully!');
            }
            fetchFinanceItems();
        } catch (error) {
            console.error('Error saving finance item:', error);
            message.error(error.response?.data?.message || 'Error saving finance item');
        }
    };

    // HR table handlers
    const addHrRow = () => {
        const newKey = String(Date.now());
        setHrRows([...hrRows, { key: newKey, item_name: '', status: '' }]);
    };

    const deleteHrRow = (key) => {
        if (hrRows.length > 1) {
            setHrRows(hrRows.filter(row => row.key !== key));
        }
    };

    const updateHrRow = (key, field, value) => {
        setHrRows(hrRows.map(row =>
            row.key === key ? { ...row, [field]: value } : row
        ));
    };

    const saveHrRow = async (row) => {
        if (!row.item_name) {
            message.error('Please enter item name');
            return;
        }

        try {
            // Get the serial number (index + 1)
            const serialNo = hrRows.findIndex(r => r.key === row.key) + 1;

            if (row.id) {
                await axios.patch(`${backUrl}/api/clearance/hr-items/${row.id}/`, {
                    section: serialNo,
                    item_name: row.item_name,
                    status: row.status
                }, {
                    headers: {
                        'Authorization': `Bearer ${authData?.access}`,
                        'Content-Type': 'application/json'
                    }
                });
                message.success('HR item updated successfully!');
            } else {
                const response = await axios.post(`${backUrl}/api/clearance/hr-items/`, {
                    section: serialNo,
                    item_name: row.item_name,
                    status: row.status
                }, {
                    headers: {
                        'Authorization': `Bearer ${authData?.access}`,
                        'Content-Type': 'application/json'
                    }
                });

                setHrRows(hrRows.map(r =>
                    r.key === row.key ? { ...r, id: response.data.id } : r
                ));
                message.success('HR item added successfully!');
            }
            fetchHrItems();
        } catch (error) {
            console.error('Error saving HR item:', error);
            message.error(error.response?.data?.message || 'Error saving HR item');
        }
    };

    // Department columns
    const deptColumns = [
        {
            title: 'Sr. No.',
            dataIndex: 'srNo',
            key: 'srNo',
            width: 80,
            align: 'center',
            render: (_, __, index) => index + 1
        },
        {
            title: 'Particulars',
            dataIndex: 'item_name',
            key: 'item_name',
            render: (_, record) => (
                <Input
                    value={record.item_name}
                    onChange={(e) => updateDeptRow(record.key, 'item_name', e.target.value)}
                    style={{ width: '100%' }}
                />
            ),
        },
        {
            title: 'Status (Pending/ Completed)',
            dataIndex: 'status',
            key: 'status',
            width: 250,
            render: (_, record) => (
                <Input
                    value={record.status}
                    onChange={(e) => updateDeptRow(record.key, 'status', e.target.value)}
                />
            ),
        },
        {
            title: '',
            key: 'action',
            width: 120,
            className: 'no-print',
            render: (_, record) => (
                <div style={{ display: 'flex', gap: '8px' }}>
                    <Button
                        type="primary"
                        size="small"
                        onClick={() => saveDeptRow(record)}
                    >
                        Save
                    </Button>
                    <Button
                        type="text"
                        danger
                        icon={<CloseOutlined />}
                        onClick={() => deleteDeptRow(record.key)}
                        disabled={deptRows.length === 1}
                    />
                </div>
            ),
        },
    ];

    // IT columns
    const itColumns = [
        {
            title: 'Sr. No',
            dataIndex: 'srNo',
            key: 'srNo',
            width: 80,
            align: 'center',
            render: (_, __, index) => `${index + 1}.`
        },
        {
            title: 'List of items',
            dataIndex: 'item_name',
            key: 'item_name',
            render: (_, record) => (
                <Input
                    value={record.item_name}
                    onChange={(e) => updateItRow(record.key, 'item_name', e.target.value)}
                />
            ),
        },
        {
            title: 'Status (Returned/ Not returned)',
            dataIndex: 'status',
            key: 'status',
            width: 250,
            render: (_, record) => (
                <Input
                    value={record.status}
                    onChange={(e) => updateItRow(record.key, 'status', e.target.value)}
                />
            ),
        },
        {
            title: '',
            key: 'action',
            width: 120,
            className: 'no-print',
            render: (_, record) => (
                <div style={{ display: 'flex', gap: '8px' }}>
                    <Button
                        type="primary"
                        size="small"
                        onClick={() => saveItRow(record)}
                    >
                        Save
                    </Button>
                    <Button
                        type="text"
                        danger
                        icon={<CloseOutlined />}
                        onClick={() => deleteItRow(record.key)}
                        disabled={itRows.length === 1}
                    />
                </div>
            ),
        },
    ];

    // Finance columns
    const financeColumns = [
        {
            title: 'Sr. No',
            dataIndex: 'srNo',
            key: 'srNo',
            width: 80,
            align: 'center',
            render: (_, __, index) => index + 1
        },
        {
            title: 'Item Name',
            dataIndex: 'item_name',
            key: 'item_name',
            render: (_, record) => (
                <Input
                    value={record.item_name}
                    onChange={(e) => updateFinanceRow(record.key, 'item_name', e.target.value)}
                />
            ),
        },
        {
            title: 'Amt. to be deducted in F&F settlement',
            dataIndex: 'amount',
            key: 'amount',
            width: 300,
            render: (_, record) => (
                <Input
                    value={record.amount}
                    onChange={(e) => updateFinanceRow(record.key, 'amount', e.target.value)}
                />
            ),
        },
        {
            title: '',
            key: 'action',
            width: 120,
            className: 'no-print',
            render: (_, record) => (
                <div style={{ display: 'flex', gap: '8px' }}>
                    <Button
                        type="primary"
                        size="small"
                        onClick={() => saveFinanceRow(record)}
                    >
                        Save
                    </Button>
                    <Button
                        type="text"
                        danger
                        icon={<CloseOutlined />}
                        onClick={() => deleteFinanceRow(record.key)}
                        disabled={financeRows.length === 1}
                    />
                </div>
            ),
        },
    ];

    // HR columns
    const hrColumns = [
        {
            title: 'Sr. No.',
            dataIndex: 'srNo',
            key: 'srNo',
            width: 80,
            align: 'center',
            render: (_, __, index) => `${index + 1}.`
        },
        {
            title: 'List of items',
            dataIndex: 'item_name',
            key: 'item_name',
            render: (_, record) => (
                <Input
                    value={record.item_name}
                    onChange={(e) => updateHrRow(record.key, 'item_name', e.target.value)}
                />
            ),
        },
        {
            title: 'Status (Returned/ Not returned)',
            dataIndex: 'status',
            key: 'status',
            width: 250,
            render: (_, record) => (
                <Input
                    value={record.status}
                    onChange={(e) => updateHrRow(record.key, 'status', e.target.value)}
                />
            ),
        },
        {
            title: '',
            key: 'action',
            width: 120,
            className: 'no-print',
            render: (_, record) => (
                <div style={{ display: 'flex', gap: '8px' }}>
                    <Button
                        type="primary"
                        size="small"
                        onClick={() => saveHrRow(record)}
                    >
                        Save
                    </Button>
                    <Button
                        type="text"
                        danger
                        icon={<CloseOutlined />}
                        onClick={() => deleteHrRow(record.key)}
                        disabled={hrRows.length === 1}
                    />
                </div>
            ),
        },
    ];

    return (
        <>
            {
                view ? (
                    <>
                        <ViewNocForm employee={employee} requestId={requestId} />
                    </>
                ) : (
                    <div style={{ maxWidth: 1000, margin: '0 auto', padding: '20px', background: '#fff' }}>
                        <style>{`
        @media print {
          .no-print { display: none !important; }
          body { 
            print-color-adjust: exact; 
            -webkit-print-color-adjust: exact;
            margin: 0;
            padding: 0;
          }
          .print-container {
            padding: 40px !important;
          }
          .page-break {
            page-break-before: always;
            margin-top: 0 !important;
            padding-top: 0 !important;
          }
          .ant-table {
            font-size: 12px !important;
          }
          .ant-table-thead > tr > th {
            background: #f0f0f0 !important;
            font-weight: bold !important;
            padding: 8px !important;
          }
          .ant-table-tbody > tr > td {
            padding: 8px !important;
          }
          .section-header {
            background: #f0f0f0 !important;
            padding: 8px 12px !important;
            font-weight: bold !important;
            font-size: 14px !important;
            margin: 20px 0 10px 0 !important;
          }
          .signature-line {
            border-bottom: 1px solid #000 !important;
            display: inline-block !important;
          }
          input, textarea {
            border: none !important;
            border-bottom: 1px solid #d9d9d9 !important;
          }
        }

        .page-break {
            page-break-before: always;
        }

        .print-container {
          padding: 20px;
        }
        
        .section-header {
          background: #f0f0f0;
          padding: 8px 12px;
          font-weight: bold;
          font-size: 16px;
          margin: 20px 0 10px 0;
        }
        
        .signature-line {
          border-bottom: 1px solid #000;
          display: inline-block;
          min-width: 200px;
          margin: 0 10px;
        }
        
        .info-row {
          display: flex;
          margin-bottom: 12px;
          flex-direction: column;
          justify-content:center;
        }
        
        .info-item {
          display: flex;
          align-items: center;
          gap: 8px;
        }
      `}</style>

                        <div className="print-container" id="noc-pdf">

                            {/* <Button
                    type="primary"
                    icon={<FilePdfOutlined />}
                    onClick={handleDownloadPDF}
                    className="no-print"
                    style={{ color: 'red', background: 'white' }}
                >
                </Button> */}

                            {
                                authData?.employee?.department === 25 && (
                                    <Button
                                        type="primary"
                                        className="no-print"
                                        onClick={handleCreateForm}
                                        style={{ borderBottom: '2px solid #0e497b', color: '#0e497b', marginLeft: 20, background: 'transparent' }}
                                    >
                                        Create Form
                                    </Button>
                                )
                            }



                            <Button
                                type="primary"
                                className="no-print"
                                onClick={handleViewForm}
                                style={{ borderBottom: '2px solid #0e497b', color: '#0e497b', marginLeft: 20, background: 'transparent' }}
                            >
                                View Form
                            </Button>
                            <Button
                                type="primary"
                                className="no-print"
                                onClick={async () => {
                                    const res = await axios.post(`${backUrl}/api/payroll/exit-interview/trigger/`, {
                                        employee: employee.id
                                    }, {
                                        headers: {
                                            Authorization: `Bearer ${authData?.access}`
                                        }
                                    })
                                    alert("Exit Interview Triggered Successfully!")
                                }}
                                style={{ borderBottom: '2px solid #0e497b', color: '#0e497b', marginLeft: 20, background: 'transparent' }}
                            >
                                Trigger Exit Interview
                            </Button>


                            {/* Modal for Create Form */}
                            <Modal
                                title="Create Employee Clearance Form"
                                open={isModalOpen}
                                onOk={handleModalOk}
                                onCancel={handleModalCancel}
                                confirmLoading={loading}
                                width={600}
                                okText="Submit"
                                cancelText="Cancel"
                            >
                                <div style={{ marginTop: 20 }}>
                                    <div style={{ marginBottom: 16 }}>
                                        <Text strong>Employee Name: </Text>
                                        <Text>{employee?.first_name}</Text>
                                    </div>

                                    <div style={{ marginBottom: 16 }}>
                                        <Text strong>Employee Code: </Text>
                                        <Text>{employee?.emp_code}</Text>
                                    </div>

                                    <div style={{ marginBottom: 16 }}>
                                        <Text strong>Designation: </Text>
                                        <Text>{employee?.designation_name}</Text>
                                    </div>

                                    <div style={{ marginBottom: 16 }}>
                                        <Text strong>Department: </Text>
                                        <Text>{employee?.department_name}</Text>
                                    </div>

                                    <div style={{ marginBottom: 16 }}>
                                        <Text strong>Joining Date: </Text>
                                        <Text>{employee?.date_of_joining}</Text>
                                    </div>

                                    <div style={{ marginBottom: 16 }}>
                                        <Text strong>Resignation Date: </Text>
                                        <Text>{employee?.date_of_leaving}</Text>
                                    </div>

                                    <div style={{ marginBottom: 16 }}>
                                        <Text strong>Relieving Date: </Text>
                                        <Text>{employee?.last_working_day}</Text>
                                    </div>

                                    <div style={{ marginBottom: 16 }}>
                                        <Text strong style={{ color: 'red' }}>* </Text>
                                        <Text strong>Correspondence Address:</Text>
                                        <TextArea
                                            rows={3}
                                            value={clearanceData.correspondence_address}
                                            onChange={(e) => setClearanceData({
                                                ...clearanceData,
                                                correspondence_address: e.target.value
                                            })}
                                            placeholder="Enter correspondence address"
                                            style={{ marginTop: 8 }}
                                        />
                                    </div>

                                    <div style={{ marginBottom: 16 }}>
                                        <Text strong style={{ color: 'red' }}>* </Text>
                                        <Text strong>Assign Department Head:</Text>
                                        <Select
                                            showSearch
                                            style={{ width: '100%', marginTop: 8 }}
                                            placeholder="Select department head"
                                            optionFilterProp="children"
                                            value={clearanceData.assigned_dept_head}
                                            onChange={(value) => setClearanceData({
                                                ...clearanceData,
                                                assigned_dept_head: value
                                            })}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {employees
                                                .filter(emp => emp.department === employee?.department)
                                                .map(emp => (
                                                    <Option key={emp.id} value={emp.id}>
                                                        {emp.first_name} - {emp.emp_code}
                                                    </Option>
                                                ))}
                                        </Select>
                                    </div>

                                    <div style={{ marginBottom: 16 }}>
                                        <Text strong style={{ color: 'red' }}>* </Text>
                                        <Text strong>Assign IT Approver:</Text>
                                        <Select
                                            showSearch
                                            style={{ width: '100%', marginTop: 8 }}
                                            placeholder="Select IT approver"
                                            optionFilterProp="children"
                                            value={clearanceData.assigned_it_approver}
                                            onChange={(value) => setClearanceData({
                                                ...clearanceData,
                                                assigned_it_approver: value
                                            })}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {employees
                                                .filter(emp => emp.department === 12)
                                                .map(emp => (
                                                    <Option key={emp.id} value={emp.id}>
                                                        {emp.first_name} - {emp.emp_code}
                                                    </Option>
                                                ))}
                                        </Select>
                                    </div>

                                    <div style={{ marginBottom: 16 }}>
                                        <Text strong style={{ color: 'red' }}>* </Text>
                                        <Text strong>Assign Finance Approver:</Text>
                                        <Select
                                            showSearch
                                            style={{ width: '100%', marginTop: 8 }}
                                            placeholder="Select finance approver"
                                            optionFilterProp="children"
                                            value={clearanceData.assigned_finance_approver}
                                            onChange={(value) => setClearanceData({
                                                ...clearanceData,
                                                assigned_finance_approver: value
                                            })}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {employees
                                                .filter(emp => emp.department === 14)
                                                .map(emp => (
                                                    <Option key={emp.id} value={emp.id}>
                                                        {emp.first_name} - {emp.emp_code}
                                                    </Option>
                                                ))}
                                        </Select>
                                    </div>

                                    <div style={{ marginBottom: 16 }}>
                                        <Text strong style={{ color: 'red' }}>* </Text>
                                        <Text strong>Assign HR Approver:</Text>
                                        <Select
                                            showSearch
                                            style={{ width: '100%', marginTop: 8 }}
                                            placeholder="Select HR approver"
                                            optionFilterProp="children"
                                            value={clearanceData.assigned_hr_approver}
                                            onChange={(value) => setClearanceData({
                                                ...clearanceData,
                                                assigned_hr_approver: value
                                            })}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {employees
                                                .filter(emp => emp.department === 25)
                                                .map(emp => (
                                                    <Option key={emp.id} value={emp.id}>
                                                        {emp.first_name} - {emp.emp_code}
                                                    </Option>
                                                ))}
                                        </Select>
                                    </div>
                                </div>
                            </Modal>

                            {/* Page 1 */}
                            <div className="mt-5">
                                <div style={{ textAlign: 'center', marginBottom: 30 }}>
                                    <Title level={3} style={{ margin: 0 }}>Baashyaam Constructions Pvt Ltd</Title>
                                    <Title level={4} style={{ margin: '10px 0 0 0', fontWeight: 600 }}>Employee Clearance Form</Title>
                                </div>

                                {/* Employee Details */}
                                <div style={{ marginBottom: 30, width: '700px' }}>
                                    <div className="info-row">
                                        <div className="info-item" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Text strong>Name:</Text>
                                            <Input
                                                style={{
                                                    width: '400px', border: "none", borderBottom: "2px solid #000",
                                                    borderRadius: 0,
                                                    boxShadow: "none"
                                                }}
                                                value={employee.first_name}
                                                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                                bordered={false}
                                                disabled
                                            />
                                        </div>
                                        <br />
                                        <div className="info-item" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Text strong>Employee Code :</Text>
                                            <Input
                                                style={{
                                                    width: '400px', border: "none", borderBottom: "2px solid #000",
                                                    borderRadius: 0,
                                                    boxShadow: "none"
                                                }}
                                                value={employee.emp_code}
                                                onChange={(e) => setFormData({ ...formData, empNo: e.target.value })}
                                                bordered={false}
                                                disabled
                                            />
                                        </div>
                                    </div>

                                    <div className="info-row">
                                        <div className="info-item" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Text strong>Organisation:</Text>
                                            <Input
                                                style={{
                                                    width: '400px', border: "none", borderBottom: "2px solid #000",
                                                    borderRadius: 0,
                                                    boxShadow: "none"
                                                }}
                                                value={employee.organisation_name}
                                                bordered={false}
                                                disabled
                                            />
                                        </div>
                                        <br />
                                        <div className="info-item" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Text strong>Designation:</Text>
                                            <Input
                                                value={employee.designation_name}
                                                onChange={(e) => setFormData({ ...formData, designation: e.target.value })}
                                                bordered={false}
                                                disabled
                                                style={{
                                                    width: '400px', border: "none", borderBottom: "2px solid #000",
                                                    borderRadius: 0,
                                                    boxShadow: "none"
                                                }} />
                                        </div>
                                        <br />
                                        <div className="info-item" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Text strong>Department:</Text>
                                            <Input
                                                value={employee.department_name}
                                                onChange={(e) => setFormData({ ...formData, dept: e.target.value })}
                                                bordered={false}
                                                disabled
                                                style={{
                                                    width: '400px', border: "none", borderBottom: "2px solid #000",
                                                    borderRadius: 0,
                                                    boxShadow: "none"
                                                }} />
                                        </div>
                                    </div>

                                    <div className="info-row" >
                                        <div className="info-item" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Text strong>Joining Date:</Text>
                                            <Input
                                                value={employee.date_of_joining}
                                                onChange={(e) => setFormData({ ...formData, joiningDate: e.target.value })}
                                                bordered={false}
                                                disabled
                                                style={{
                                                    width: '400px', border: "none", borderBottom: "2px solid #000",
                                                    borderRadius: 0,
                                                    boxShadow: "none"
                                                }} />
                                        </div>
                                    </div>
                                </div>

                                <div className="info-row" style={{ width: '700px' }}>
                                    <div className="info-item" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Text strong>Resignation Date:</Text>
                                        <Input
                                            value={employee.date_of_leaving}
                                            onChange={(e) => setFormData({ ...formData, resignationDate: e.target.value })}
                                            bordered={false}
                                            disabled
                                            style={{
                                                width: '400px', border: "none", borderBottom: "2px solid #000",
                                                borderRadius: 0,
                                                boxShadow: "none"
                                            }} />
                                    </div>
                                    <br />
                                    <div className="info-item" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Text strong>Relieving Date:</Text>
                                        <Input
                                            value={employee.last_working_day}
                                            onChange={(e) => setFormData({ ...formData, relievingDate: e.target.value })}
                                            bordered={false}
                                            disabled
                                            style={{
                                                width: '400px', border: "none", borderBottom: "2px solid #000",
                                                borderRadius: 0,
                                                boxShadow: "none"
                                            }} />
                                    </div>
                                </div>

                                {/* Department Section */}
                                {
                                    (authData?.employee?.department === 25 || authData?.employee?.department_name === employee?.department) && (
                                        <div>
                                            <div className="section-header">CLEARANCE FROM DEPARTMENT HEAD</div>
                                            <Table
                                                columns={deptColumns}
                                                dataSource={deptRows}
                                                pagination={false}
                                                bordered
                                                size="middle"
                                            />
                                            <Button
                                                type="dashed"
                                                onClick={addDeptRow}
                                                icon={<PlusOutlined />}
                                                className="no-print"
                                                style={{ marginTop: 10 }}
                                            >
                                                Add Row
                                            </Button>

                                            {isDeptHeadAssigned() && (
                                                <Button
                                                    type="primary"
                                                    onClick={handleDeptSubmit}
                                                    className="no-print"
                                                    style={{ marginTop: 10, marginLeft: 10, background: '#52c41a' }}
                                                >
                                                    Submit Department Clearance
                                                </Button>
                                            )}

                                            <div style={{ marginTop: 20, lineHeight: '2.5' }}>
                                                <div>
                                                    <Text strong>Employee Signature:</Text>
                                                    <span className="signature-line"></span>
                                                    <Text strong>Date:</Text>
                                                    <span style={{ marginLeft: 8 }}>{currentDate}</span>
                                                </div>
                                                <div>
                                                    <Text strong>Signature of person to whom handing over was done:</Text>
                                                    <span className="signature-line" style={{ minWidth: 150 }}></span>
                                                    <Text strong>Date:</Text>
                                                    <span style={{ marginLeft: 8 }}>{currentDate}</span>
                                                </div>
                                                <div>
                                                    <Text strong>Signature of Departmental Head:</Text>
                                                    <span className="signature-line"></span>
                                                    <Text strong>Date:</Text>
                                                    <span style={{ marginLeft: 8 }}>{currentDate}</span>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>

                            <br />

                            {/* IT Section */}
                            {
                                (authData?.employee?.department === 25 || authData?.employee?.department === 12) && (
                                    <div className="page-break">
                                        <div className="section-header">CLEARANCE FROM - IT</div>
                                        <Table
                                            columns={itColumns}
                                            dataSource={itRows}
                                            pagination={false}
                                            bordered
                                            size="middle"
                                        />
                                        <Button
                                            type="dashed"
                                            onClick={addItRow}
                                            icon={<PlusOutlined />}
                                            className="no-print"
                                            style={{ marginTop: 10 }}
                                        >
                                            Add Row
                                        </Button>

                                        {isItApproverAssigned() && (
                                            <Button
                                                type="primary"
                                                onClick={handleItSubmit}
                                                className="no-print"
                                                style={{ marginTop: 10, marginLeft: 10, background: '#52c41a' }}
                                            >
                                                Submit IT Clearance
                                            </Button>
                                        )}

                                        <div style={{ marginTop: 20, marginBottom: 40 }}>
                                            <Text strong>Signature (IT):</Text>
                                            <span className="signature-line"></span>
                                            <Text strong>Date:</Text>
                                            <span style={{ marginLeft: 8 }}>{currentDate}</span>
                                        </div>
                                    </div>
                                )
                            }

                            {/* Finance Section */}
                            {
                                (authData?.employee?.department === 25 || authData?.employee?.department === 14) && (
                                    <div className={authData?.employee?.department === 14 ? "page-break" : ""}>
                                        {authData?.employee?.department === 14 && (
                                            <div style={{ textAlign: 'center', marginBottom: 30 }}>
                                                <Title level={3} style={{ margin: 0 }}>Baashyaam Constructions Pvt Ltd</Title>
                                                <Title level={4} style={{ margin: '10px 0 0 0', fontWeight: 600 }}>Employee Clearance Form</Title>
                                            </div>
                                        )}

                                        <div className="section-header">CLEARANCE FROM FINANCE</div>
                                        <Table
                                            columns={financeColumns}
                                            dataSource={financeRows}
                                            pagination={false}
                                            bordered
                                            size="middle"
                                        />
                                        <Button
                                            type="dashed"
                                            onClick={addFinanceRow}
                                            icon={<PlusOutlined />}
                                            className="no-print"
                                            style={{ marginTop: 10 }}
                                        >
                                            Add Row
                                        </Button>

                                        {isFinanceApproverAssigned() && (
                                            <Button
                                                type="primary"
                                                onClick={handleFinanceSubmit}
                                                className="no-print"
                                                style={{ marginTop: 10, marginLeft: 10, background: '#52c41a' }}
                                            >
                                                Submit Finance Clearance
                                            </Button>
                                        )}

                                        <div style={{ marginTop: 20 }}>
                                            <Text strong>Signatures: (Finance)</Text>
                                            <span className="signature-line"></span>
                                            <Text strong>Date:</Text>
                                            <span style={{ marginLeft: 8 }}>{currentDate}</span>
                                        </div>
                                    </div>
                                )
                            }

                            <br />

                            {/* HR Section */}
                            {
                                authData?.employee?.department === 25 && (
                                    <div className="page-break">

                                        <div className="section-header">CLEARANCE FROM HR</div>
                                        <Table
                                            columns={hrColumns}
                                            dataSource={hrRows}
                                            pagination={false}
                                            bordered
                                            size="middle"
                                        />
                                        <Button
                                            type="dashed"
                                            onClick={addHrRow}
                                            icon={<PlusOutlined />}
                                            className="no-print"
                                            style={{ marginTop: 10 }}
                                        >
                                            Add Row
                                        </Button>

                                        {isHrApproverAssigned() && (
                                            <Button
                                                type="primary"
                                                onClick={handleHrSubmit}
                                                className="no-print"
                                                style={{ marginTop: 10, marginLeft: 10, background: '#52c41a' }}
                                            >
                                                Submit HR Clearance
                                            </Button>
                                        )}

                                        <div style={{ marginTop: 30, marginBottom: 20 }}>
                                            <Text strong>
                                                CLEARANCE FROM HR (to be given only after obtaining all the above clearances and completion of exit interview)
                                            </Text>
                                        </div>

                                        <div style={{ marginBottom: 30 }}>
                                            <Text strong>Signature: (HR)</Text>
                                            <span className="signature-line"></span>
                                            <Text strong>Date:</Text>
                                            <span style={{ marginLeft: 8 }}>{currentDate}</span>
                                        </div>

                                        <div style={{ border: '1px solid #d9d9d9', padding: 20 }}>
                                            <Text strong style={{ display: 'block', marginBottom: 15 }}>
                                                Address & Phone No. for further Correspondence: (to be given by employee)
                                            </Text>
                                            <TextArea
                                                value={formData.address}
                                                onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                                                placeholder="Address"
                                                rows={3}
                                                style={{ marginBottom: 10 }}
                                            />
                                            <Input
                                                value={formData.phone}
                                                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                                                placeholder="Phone No."
                                            />
                                        </div>
                                    </div>
                                )
                            }
                        </div>

                    </div>
                )
            }
        </>

    );
}